import React from 'react'
import { Col, Row } from 'react-bootstrap'

type TStatusPanel = {
  item?: {
    status?: string
    [key: string]: any
  }
}
const StatusPanel = (props: TStatusPanel): React.ReactElement => {
  const { item = {} } = props

  return (
    <Row>
      <Col>CONTENT</Col>
      {item.status}
    </Row>
  )
}

export default StatusPanel
